<template lang="html">
  <section class="home-empresa row-between container ais">
    <div class="contenedor-left">
      <div class="contenedor-home container row-between ais">
        <article class="home-el" :title="$t('home_empresa.publicar_practicas')">
          <router-link :to="$t('enlaces.nueva_oferta') + '/practicas'" class="enlace-cover"></router-link>

          <h3 v-html="$t('home_empresa.nueva_practicas')"></h3>

          <p v-html="$t('home_empresa.publicar_practicas')"></p>

          <h4 class="bubble add">+</h4>
        </article>
        <article class="home-el" :title="$t('home_empresa.publicacion_practicas_candidato')">
          <router-link :to="$t('enlaces.propuesta_practicas')" class="enlace-cover"></router-link>

          <h3 v-html="$t('home_empresa.nueva_practicas_candidato')"></h3>

          <p v-html="$t('home_empresa.publicacion_practicas_candidato')"></p>

          <h4 class="bubble add">+</h4>
        </article>
        <article class="home-el" :title="$t('home_empresa.publicar_practica_formacion')">
          <router-link :to="$t('enlaces.nueva_oferta') + '/formacion'" class="enlace-cover"></router-link>

          <h3 v-html="$t('home_empresa.nueva_practica_formacion')"></h3>

          <p v-html="$t('home_empresa.publicar_practica_formacion')"></p>

          <h4 class="bubble add">+</h4>
        </article>
        <article class="home-el" :title="$t('home_empresa.texto_ofertas_practicas')">
          <router-link :to="$t('enlaces.mis_ofertas')" class="enlace-cover"></router-link>

          <h3 v-html="$t('home_empresa.ofertas_practicas')"></h3>
          <p v-html="$t('home_empresa.texto_ofertas_practicas')"></p>
        </article>
      </div>

      <div class="contenedor-encuestas">
        <modulo-encuestas></modulo-encuestas>
      </div>
    </div>

    <div class="container -comunicaciones" v-if="comunicaciones.length > 0">
      <div class="contenedor-modulo-comunicaciones" v-if="comunicaciones.length > 0">
        <modulo-comunicaciones></modulo-comunicaciones>
      </div>
    </div>
    <popup-aceptar-comunicaciones-empresa :show="popupAceptaComunicaciones" @guardar="aceptarComunicaciones">
    </popup-aceptar-comunicaciones-empresa>
  </section>
</template>

<script lang="js">

import { mapGetters, mapActions, mapMutations } from 'vuex';

import moduloEncuestas from '@/components/views/home/modulo-encuestas'

import moduloComunicaciones from './modulo-comunicaciones';

import popupAceptarComunicacionesEmpresa from '@/components/parts/popup-aceptar-comunicaciones-empresa';

export default {
  name: 'home-empresa',
  data() {
    return {
      clicked: false,
      popupAceptaComunicaciones: false
    }
  },
  mounted() {
      //this.requestNumProcesos();
    this.requestProcesos();
    if (this.clickPopupDocumentacionEmpresa == false && window.localStorage.getItem("PopupDocumentacionEmpresa") == 'false') {
        this.setError('documentacionEmpresa');
        window.localStorage.setItem("PopupDocumentacionEmpresa", true);
      }
      if (this.faltaDatoDeseaRecibirInformacionUni == true && window.localStorage.getItem("faltaDatoDeseaRecibirInformacionUni") == 'true') {
        this.popupAceptaComunicaciones = true;
      }
  },
  components: {
    'modulo-encuestas': moduloEncuestas,
    'modulo-comunicaciones': moduloComunicaciones,
    'popup-aceptar-comunicaciones-empresa': popupAceptarComunicacionesEmpresa,
  },
  methods: {
    ...mapActions(['requestNumProcesos', 'requestProcesos', 'requestDatosFirmanteEmpresa', 'changeDatosFirmanteEmpresa', 'setError']),
    ...mapMutations({
      setCompleteError: 'setCompleteError'
    }),
    isNullOrEmpty(value) {
      return value == null || value === "";
    },
    aceptarComunicaciones(data) {
      this.popupAceptaComunicaciones = false;
    }
  },
  computed: {
    ...mapGetters({
      colors: 'basicColors',
      style: 'getStyles',
      //procesos: 'getNumProcesos',
      loading: 'getLoadingProcesos',
      comunicaciones: 'getComunicaciones',
      firmaConvenio: 'getFirmaConvenio',
      clickPopupDocumentacionEmpresa: 'getClickPopUpDocumentacionEmpresa',
      faltaDatoDeseaRecibirInformacionUni: 'getFaltaDatoDeseaRecibirInformacionUni'
    }),
    procesosPracticasActivos: function () {
      let procesos
      if (!!this.procesos) {
        procesos = this.procesos.numProcesosActivosPracticas
      }
      return procesos;
    },
    procesosEmpleoActivos: function () {
      let procesos
      if (!!this.procesos) {
        procesos = this.procesos.numProcesosActivosEmpleo
      }
      return procesos;
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/css/colors.scss";

.home-empresa {
  max-width: 1200px;
  padding-top: 70px;
  min-height: calc(100vh - 309px);
}

.contenedor-home {
  padding-bottom: 0px;
  max-width: 800px;
}

.home-el {
  width: calc(50% - 10px);
  max-width: 380px;
  padding: 25px;
  margin-bottom: 50px;
  text-align: left;
  position: relative;

  &:nth-child(3) {
    margin-bottom: 0;
  }

  &:nth-child(4) {
    margin-bottom: 0;
  }
}

.home-el h3 {
  font-size: 16px;
  margin-bottom: 10px;
  font-weight: 400;
}

.bubble {
  position: absolute;
  right: 20px;
  top: 0;
  transform: translateY(-50%);
  height: 55px;
  line-height: 55px;
  width: 55px;
  font-weight: 800;
  text-align: center;
  font-size: 21px;
  border-radius: 100%;

  &[loading="true"] {
    font-size: 0;
    background-image: url(/static/img/loading-white.svg);
    background-position: center;
    background-size: 40px auto;
    background-repeat: no-repeat;
  }
}

.bubble.add {
  font-size: 36px;
}

.container.-comunicaciones {
  width: auto;
}

.contenedor-left:first-child:last-child {
  width: 100%;
}

@media screen and (max-width: 1185px) {
  .home-empresa {
    justify-content: center;
    -webkit-justify-content: center;
  }

  .contenedor-modulo-comunicaciones {
    margin-top: 50px;
    max-width: 768px;
    padding-bottom: 50px;
  }
}

@media screen and (max-width: 767px) {
  .contenedor-home {
    padding-top: 0px;
    padding-bottom: 25px;
  }

  .home-el {
    max-width: 100%;
    width: 100%;

    &:nth-child(3) {
      margin-bottom: 50px;
    }

    &:last-of-type {
      margin-bottom: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/views/home/home-empresa.vue